import { AccountPermission } from 'modules/permissions/constants';
import { IChargingModelData } from 'modules/payments/types';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useCheckAccountPermission } from 'modules/account/hooks/useCheckAccountPermission';

export const useFreemiumChargingModel = (
  currentChargingModel: IChargingModelData,
) => {
  const { isFreemium } = useAccountStatus();

  const hasAccountStatusAccess = useCheckAccountPermission({
    permission: AccountPermission.AccountStatus,
  });
  const hasBillingAccess = useCheckAccountPermission({
    permission: AccountPermission.Billing,
  });

  const shouldShowFreemium =
    isFreemium &&
    hasAccountStatusAccess &&
    hasBillingAccess &&
    currentChargingModel?.balance?.balanceInRequests === 0;

  return { shouldShowFreemium };
};
